import { render, staticRenderFns } from "./vsNavbarItems.vue?vue&type=template&id=fd9aae46&"
import script from "./vsNavbarItems.vue?vue&type=script&lang=js&"
export * from "./vsNavbarItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsNavbarItems.vue"
export default component.exports